import useAccountQuery from 'api/queries/useAccountQuery';
import EBTCardSummary from 'features/shop/cart/EBTPaymentFlow/shared/EBTCardSummary';
import {
    CreditCardCharge,
    StepCard,
    StepHeading,
    SuccessIcon,
} from 'features/shop/cart/EBTPaymentFlow/shared/FlowPresentation';
import Button from 'honeydew/Button';
import { EBTCardLast4 } from 'shared/ebt/EBTSharedUI';

/**
 * Success screen component displayed after a successful EBT payment has been processed.
 * Shows payment confirmation details, remaining EBT card balance, and provides a way to close the flow.
 *
 * @param {Object} props - The component props
 * @param {Object} props.ebtCard - EBT card information
 * @param {string} props.ebtCard.last4 - Last 4 digits of the EBT card number
 * @param {Object} props.flowData - Payment flow data containing API response
 * @param {Object} props.flowData.apiResponse - API response from payment processing
 * @param {Object} props.flowData.apiResponse.data - Payment data from API response
 * @param {number} props.flowData.apiResponse.data.ebtAmount - Amount charged to EBT card
 * @param {Function} props.handleClose - Callback function to close the payment flow
 * @returns {JSX.Element} The rendered success screen component
 */
function CreateEBTPaymentSuccess({ ebtCard, flowData, handleClose }) {
    const { data: account = {} } = useAccountQuery();
    const apiResponse = flowData?.apiResponse?.data;

    return (
        <div className="space-y-15">
            <div className="flex items-center gap-10">
                <SuccessIcon />
                <StepHeading>Success!</StepHeading>
            </div>
            <p data-testid="ebt-payment-successful-message">
                Payment of{' '}
                <span className="text-brand-primary font-grotesk-bold">${apiResponse?.ebtAmount?.toFixed(2)}</span> from{' '}
                <EBTCardLast4 last4={ebtCard?.last4} className="font-grotesk-bold" /> has been applied to your order.
            </p>
            <CreditCardCharge
                orderChargeDate={account?.nextOrder?.orderChargeDate?.date}
                marketCloseDate={account?.marketCloseDate?.date}
                className="text-body-md text-black"
            />
            <StepCard>
                <EBTCardSummary balanceLabel="Remaining Balance" last4={ebtCard?.last4} />
            </StepCard>
            <Button onClick={handleClose}>Done</Button>
        </div>
    );
}

export default CreateEBTPaymentSuccess;
